import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsApi } from '../../../infrastructure/api/investigations.api';
import type { SendForClosureApprovalCommand } from './send-for-closure-approval.command';
import type { SendForClosureApprovalResult } from './send-for-closure-approval.result';

@Injectable({ providedIn: 'root' })
export class SendForClosureApprovalUseCase {
  private readonly _api = inject(InvestigationsApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: SendForClosureApprovalCommand): Observable<SendForClosureApprovalResult> {
    return this._api.sendForClosureApproval(command.investigationId, { statusId: command.statusId }).pipe(
      tap(() => {
        this._toast.success(
          'Submitted for closure approval',
          'The investigation has been submitted for closure approval.',
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to submit for closure approval',
          'Please try again or contact support if the issue persists.',
        );
        return throwError(() => error);
      }),
    );
  }
}
